import { render, staticRenderFns } from "./editResourceStoreSpecification.vue?vue&type=template&id=db902c4a&scoped=true"
import script from "./editResourceStoreSpecification.vue?vue&type=script&lang=js"
export * from "./editResourceStoreSpecification.vue?vue&type=script&lang=js"
import style0 from "./editResourceStoreSpecification.vue?vue&type=style&index=0&id=db902c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db902c4a",
  null
  
)

export default component.exports